import { useEffect, useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { useParams } from "react-router-dom"
import Get from "../../api/Get";
import Post from "../../api/Post";
import { APPOINTMENT_CANCEL, CHECK_CITA_REASIGNED } from "../../api/Routes";
import LoadingList from "../../loader/LoadingList";
import { getTokenExternal } from "../../utils/getTokenExternal";
import LinkExpirado from "./LinkExpirado";
import Reagendar from "./Reagendar";
import ReagendarCancelar from "./ReagendarCancelar";
import Reasignar from "./Reasignar";
import SeleccionarFecha from "./SeleccionarFecha";

function ModificarCita({t}){
    const { id } = useParams();
    const [loading, setLoading] = useState(true)
    const [cita, setCita] = useState(null)
    const [currentStep, setCurrentStep] = useState("")
    const [errorService, setErrorService] = useState(null)
    const [initialData, setInitialData] = useState({
        account: '',
        name: '',
        middleName: '',
        lastName: '',
        seccondSurname: '',
        phoneNumber: '',
        email: '',
        identityDocumentType: '',
        documentNumber: '',
        hourInit: "",
        schedule: "",
        doctorId: "",
        doctorName: "",
        especialidadName: "",
        especialidadId: ""
        
    })

    //console.log(initialData)

    useEffect(() => {
        setLoading(true)
        try {
            async function fetchTokenExternal(){
                let response = await getTokenExternal({id: 2})
                if(response.data.access_token){
                    try {
                        const resp = await Get({url: `${CHECK_CITA_REASIGNED}/${atob(id)}` , access_token: response.data.access_token})
                        console.log(resp)
                        if(resp.data.state){
                            setCita(resp.data.data)
                            setInitialData(prev=>({
                                ...prev,
                                account: resp.data.data.patientDTO.account,
                                name: resp.data.data.patientDTO.name,
                                middleName: resp.data.data.patientDTO.middleName,
                                lastName: resp.data.data.patientDTO.lastName,
                                seccondSurname: resp.data.data.patientDTO.seccondSurname,
                                phoneNumber: resp.data.data.patientDTO.phone,
                                email: resp.data.data.patientDTO.email,
                                identityDocumentType: resp.data.data.patientDTO.identityDocumentType,
                                documentNumber: resp.data.data.patientDTO.documentNumber
                            }))
                            if(resp.data.data.appointmentStatus === "Fallida"){
                                setCurrentStep('declined')
                            }else{
                                setCurrentStep('reagendarcancelar')
                            }
                            
                        }else{
                            setCurrentStep("linkexpirado")
                            setErrorService(resp.data.error)
                        }
                        setLoading(false)
                    } catch (error) {
                        setLoading(false)
                        setCurrentStep('errorServer')
                    }
                }
            }
            fetchTokenExternal();
        } catch (error) {
            setLoading(false)
            setCurrentStep('errorServer')
        }
    }, [id])

    

    const handleChoice = (reagendar) => {
        if(reagendar){
            setCurrentStep("seleccionarFecha")
        }else{
            setLoading(true)
            try {
                async function cancelAppointment(){
                    let response = await getTokenExternal({id: 2})
                    if(response.data.access_token){
                        const data = {
                            id: cita?.id,
                            appointmentStatus : cita?.appointmentStatus
                        }
                        try{
                            const resp = await Post({url: APPOINTMENT_CANCEL, data: data, access_token: response.data.access_token, header: true})
                            //console.log(response)
                            if(resp.data.state){
                                setCurrentStep("cancelar")
                            }else{
                                setCurrentStep('errorServer')
                            }
                            setLoading(false)
                        }catch (error) {
                            setLoading(false)
                            setCurrentStep('errorServer')
                        }
                        
                        
                    }else{
                        setCurrentStep('errorServer')
                        setLoading(false)
                    }
                }
                cancelAppointment();
            } catch (error) {
                setCurrentStep('errorServer')
                setLoading(false)
            }
        }
    }
    const handleChoiceStep = (step) =>{
        setCurrentStep(step)
    }

    const steps = {
        reagendarcancelar: <ReagendarCancelar cita={cita} handleChoice={handleChoice} />,
        reagendar: <Reagendar cita={cita} handleNext={handleChoiceStep}/>,
        seleccionarFecha: <SeleccionarFecha cita={cita} handleNext={handleChoiceStep} setInitialData={setInitialData}/>,
        reasignar: <Reasignar cita={cita} initialData={initialData} handleNext={handleChoiceStep} setCurrentStep={setCurrentStep}/>, 
        linkexpirado: <LinkExpirado error={errorService}/>,
        reservadoExitosamente: <Row><Col xs="12" md={{span: 4, offset: 4}}><Card><Card.Body><div className="text-center"><h5>{t('citas_nosotros')}</h5><p>{t('contactare_breve')}</p></div></Card.Body></Card></Col></Row>,
        errorServer: <Row><Col xs="12" md={{span: 4, offset: 4}}><Card><Card.Body><h5 className="text-center">Estamos teniendo problemas para procesar la información. Intente más tarde por favor.</h5></Card.Body></Card></Col></Row>,
        declined: <Row><Col xs="12" md={{span: 4, offset: 4}}><Card><Card.Body><h5 className="text-center">No se puede accesar a la cita porque se a declinado el consentimiento</h5></Card.Body></Card></Col></Row>,
        cancelar: <Row><Col xs="12" md={{span: 4, offset: 4}}><Card><Card.Body><h5 className="text-center">Acción exitosa usted ha cancelado la cita</h5></Card.Body></Card></Col></Row>
    }


    return (
        <Container fluid className="content h-100vh py-5">
            {
                loading ? <LoadingList texto={t('espere_porfavor')}/> :
                <>
                {
                    (currentStep === 'seleccionarFecha' || currentStep === 'reasignar') &&
                    <Row className="mb-4">
                        <Col>
                            <div className="multi-step">
                                <ul className="multi-step-list">
                                    <li className={`multi-step-item ${currentStep === 'seleccionarFecha' ? 'current' : ''}`}>
                                        <div className="item-wrap">
                                        <p className="item-title">Paso 1</p>
                                        </div>
                                    </li>
                                    <li className={`multi-step-item ${currentStep === 'reasignar' ? 'current' : ''}`}>
                                        <div className="item-wrap">
                                        <p className="item-title">Paso 2</p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </Col>
                    </Row>
                }
                {steps[currentStep]}
                </>
            }
        </Container>
    )
}

export default withTranslation()(ModificarCita)